import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectNotificationsStatus } from '../../../../../notifications/gql/fragments/generated/ProjectNotificationsStatus';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectSheetHeaderDataFragment = { __typename?: 'Project', id: string, rootAssetId: string, notificationsEnabled?: boolean | null };

export const ProjectSheetHeaderData = /*#__PURE__*/ gql`
    fragment ProjectSheetHeaderData on Project {
  id
  rootAssetId
  ...ProjectNotificationsStatus
}
    ${ProjectNotificationsStatus}` as unknown as DocumentNode<ProjectSheetHeaderDataFragment, unknown>;

        

        
export const useProjectSheetHeaderDataFragment = (
  input: string | Omit<UseFragmentOptions<ProjectSheetHeaderDataFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectSheetHeaderDataFragment>({
    fragment: ProjectSheetHeaderData,
    fragmentName: 'ProjectSheetHeaderData',
    ...options,
  });
};
  
        